import React from 'react'
import { DataTable } from '@ztechapps/webui.data-tools'
import { useSerialNumberSelectListContext } from './Context'
import { ListHeader } from './ListHeader'
import { ListRow } from './ListRow'
import type { ListFieldConfig } from '@ztechapps/common.hook'
import { Alert, Stack } from 'react-bootstrap'
import { HorizontalStack } from '@ztechapps/webui.util'
import { ListFieldTypeEnum } from '@ztechapps/common.hook'
import { InventoryBySerialNumberStatusEnum } from '@ztechapps/common.contract'
import map from 'lodash/map'

const listFieldConfig: ListFieldConfig = {
  code: {
    name: 'code',
    displayName: 'Serial Number',
    index: 0,
    size: 300,
  },
  status: {
    name: 'status',
    displayName: 'Status',
    index: 1,
    size: 150,
    excludeOnSearch: true,
    type: ListFieldTypeEnum.select,
    fieldSettings: {
      listValues: map(InventoryBySerialNumberStatusEnum, (item) => item),
    },
  },
  batchCode: {
    name: 'batchCode',
    displayName: 'Batch Code',
    index: 2,
    size: 200,
    isVisible: false,
  },
  remarks: {
    name: 'remarks',
    index: 3,
    size: 300,
  },
  tags: {
    name: 'tags',
    index: 4,
    size: 200,
    isVisible: false,
  },
} as const satisfies ListFieldConfig

export const Layout = () => {
  const context = useSerialNumberSelectListContext()
  const { inventoryBySerialNumberList, listWithSelection, requiredQty, maxSelection } = context
  const { list } = listWithSelection
  const defaultListResult = { ...inventoryBySerialNumberList, list }

  const selectedCount = listWithSelection.selectedList.length
  const isRequiredMet = requiredQty ? selectedCount === requiredQty : true

  return (
    <Stack gap={3}>
      <div>
        <Alert variant={isRequiredMet ? 'success' : 'warning'} className="mb-0">
          <HorizontalStack className="justify-content-between">
            <div>
              <strong>Selected: {selectedCount}</strong>
              {requiredQty && <> / Required: {requiredQty}</>}
              {maxSelection && <> (Max: {maxSelection})</>}
            </div>
          </HorizontalStack>
        </Alert>
      </div>

      <DataTable
        height={'50vh'}
        fields={listFieldConfig}
        name="serial-number-select-list-v1"
        listResult={defaultListResult}
        row={ListRow}
        stats="serial numbers"
        head={ListHeader}
      />
    </Stack>
  )
}
